<script>
import { Bar } from "vue-chartjs";
import { mapState } from 'vuex'

export default {
  name: "Home",
  data() {
    return {
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return Math.round(data["datasets"][0]["data"][tooltipItem["index"]]) + "%";
            }
          }
        },
        responsive: true,
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Share of Users (%)",
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 100,
                display: true
              },
            },
          ],
        },
      },
    };
  },
  extends: Bar,
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  watch: {
    filters: {
      handler() {
        this.renderChart(this.chartdata, this.options);
      },
      immediate: true,
      deep: true,
    },
    hasEnoughData () {
      this.$emit('hasEnoughData', this.hasEnoughData)
    }
  },
  computed: {
    ...mapState(['medication']),
    filteredMedication() {
      let filteredMedication = this.medication.filter((row) => {
        let isRowInFilter = true;
        if (this.filters.mol) {
          if (this.filters.mol !== row.mol) {
            isRowInFilter = false;
          }
        }
        if (this.filters.painIntensity) {
          if (this.filters.painIntensity !== row.painintensity) {
            isRowInFilter = false;
          }
        }
        if (this.filters.painPosition) {
          if (this.filters.painPosition !== row.painposition) {
            isRowInFilter = false;
          }
        }
        if (
          (!this.filters.mol &&
            !this.filters.painIntensity &&
            !this.filters.painPosition) ||
          isRowInFilter
        ) {
          return row;
        }
      });
      return filteredMedication;
    },
    constructedData() {
      let data = [0, 0, 0];
      let nb_migraines = 0;
      this.filteredMedication.map((element) => {
        data[0] = data[0] + element.nb_unhelpful;
        data[1] = data[1] + element.nb_somewhathelpful;
        data[2] = data[2] + element.nb_helpful;
        nb_migraines = nb_migraines + element.nb_unhelpful + element.nb_somewhathelpful + element.nb_helpful;
      });
      data[0] = (data[0] / nb_migraines) * 100;
      data[1] = (data[1] / nb_migraines) * 100;
      data[2] = (data[2] / nb_migraines) * 100;
      return data;
    },
    hasEnoughData () {
      let nb_migraines = 0;
      this.filteredMedication.map((element) => {
        nb_migraines = nb_migraines + element.nb_unhelpful + element.nb_somewhathelpful + element.nb_helpful;
      });
      return nb_migraines >= 100;
    },
    chartdata() {
      return {
        // labels: ["nb_unhelpful", "nb_somewhathelpful", "nb_helpful"],
        labels: ["", "", ""],
        datasets: [
          {
            backgroundColor: ["#FF5163", "#2EA8CC", "#58B78C"],
            data: this.constructedData,
          },
        ],
      };
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
